<div style="overflow-y: auto;" mdbModal #addEditProducto="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 *ngIf="mode==='ADD'" class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
        <h4 *ngIf="mode==='EDIT'" class="modal-title w-100 text-left" id="myModalLabel">Editar</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="addEditProducto.hide()"><span aria-hidden="true">×</span></button>
      </div>
      <div class="modal-body">
        <app-productos-form-add-edit (onSuccess)="onSuccessSaveOrEdit()"></app-productos-form-add-edit>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
          (click)="addEditProducto.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button type="submit" class="btn btn-sm btn-secondary waves-light" size="sm" mdbWavesEffect (click)="guardar()">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>